import {Component, OnInit} from '@angular/core';
import {DynamicDialogConfig, DynamicDialogRef} from "primeng/dynamicdialog";
import {MessageService, SelectItem} from "primeng/api";
//import {Product} from "../../akturk/domain/product";
import {TranslatePipe, TranslateService} from "@ngx-translate/core";
import {PropertyModel} from '../models/property-model';
import {PropertyService} from '../services/property.service';
import {TableModule} from 'primeng/table';
import {FormsModule} from '@angular/forms';
import {DropdownModule} from 'primeng/dropdown';
import {Button, ButtonDirective} from 'primeng/button';


@Component({
    selector: 'app-property-form',
    templateUrl: './property-form.component.html',
    styleUrls: ['./property-form.component.scss'],
    providers: [MessageService], imports: [
        TableModule,
        FormsModule,
        DropdownModule,
        Button,
        TranslatePipe,
        ButtonDirective,
    ],
    standalone: true
})
export class PropertyFormComponent implements OnInit {


    propertyLabel: string | undefined;
    propertyKey: string | undefined;
    languages: SelectItem[] | undefined;
    propertyModelList: PropertyModel[] = [];
    //clonedPropertyModelList: { [s: string]: PropertyModel; } = {};
    clonedPropertyModelList: { [key: string]: PropertyModel } = {};

    constructor(public ref: DynamicDialogRef,
                public config: DynamicDialogConfig,
                private propertyService: PropertyService,
                private messageService: MessageService,
                private translate: TranslateService,) {
    }

    ngOnInit() {

        this.propertyLabel = this.config.data['propertyLabel'];
        this.propertyKey = this.config.data['propertyKey'];
        if (this.propertyKey) {
            this.propertyService.getPropertiesByKey(this.propertyKey).then(value => {
                if (value) {
                    this.propertyModelList = value;
                    console.log(value);
                }
            });
        }
        this.languages = [{label: 'Deutsch', value: 'de'}, {label: 'Englisch', value: 'en'}]
    }

    onRowEditInit(property: PropertyModel) {
        this.clonedPropertyModelList[property.id] = {...property};
    }

    onRowEditSave(product: PropertyModel) {
        /*
        if (product.price > 0) {
            delete this.clonedProducts[product.id];
            this.messageService.add({severity:'success', summary: 'Success', detail:'Product is updated'});
        }
        else {
            this.messageService.add({severity:'error', summary: 'Error', detail:'Invalid Price'});
        }*/
    }

    onRowEditCancel(property: PropertyModel, index: number) {
        if (this.propertyModelList) {
            this.propertyModelList[index] = this.clonedPropertyModelList[property.id];
        }
        if (this.propertyModelList && property?.id) {

            //ToDo: was macht das hier...
            //delete this.propertyModelList[property.id];
        }
    }

    addNewProperty() {

        if (!this.propertyModelList) {
            this.propertyModelList = [];
        }

        if (!this.propertyKey) {
            this.propertyKey = "";
        }

        this.propertyModelList.push({
            id: "",
            dtype: this.propertyKey,
            dtext: "",
            dkey: "",
            language: "DE",
            weighting: 0,
            order: 0
        })
    }

    saveProperties() {

        if (!this.propertyModelList) return;


        this.propertyService.postProperties(this.propertyModelList.pop()).subscribe({
            next: value => {
                if (this.propertyModelList && this.propertyModelList.length > 0) {
                    this.saveProperties();
                } else {
                    this.ref.close(true);
                }


                console.log(value);
            },
            error: err => {
                console.error(err);
            }
        })
    }

    onRowReorder(reorder: any) {

        if (!this.propertyModelList)
            return;

        const item = reorder.dragIndex;
        const position = reorder.dropIndex;


        let start: number = position > item ? item : position;

        for (let i = start; i < this.propertyModelList.length; i++) {
            this.propertyModelList[i].order = i;
        }

        console.log(reorder);
    }
}
